export default function Release20250520() {
    return (
        <>
            <p>
                Hipers ambition er klar: At være den førende leverandør af lynhurtigt og stabilt internet. 
                Den ambition kvitterer forbrugerne for i Loyalty Groups toneangivende årlige forbrugerundersøgelse, 
                hvor danske internetkunder er blevet hørt om forholdet til og oplevelsen af otte forskellige internetudbydere.  
            </p>
            <p>
                ”Hiper er nu for 6. år i træk den internetudbyder, der vurderes til at give ”mest værdi for pengene”. 
                Samtidig vil rigtig mange stille sig op bag kabeltromlen og anbefale Hiper til venner og bekendte, da 
                Hiper leverer den højeste score på ”flest vil anbefale”, siger Lars Jepsen, researchchef og senior 
                partner hos Loyalty Group, der står bag det årlige brancheindex for internet.  
            </p>
            <p>
                <strong>Det skal være endnu nemmere at være fiberkunde hos Hiper</strong><br/>
                Hiper er lykkedes med at øge den årlige omsætning og vinde markante markedsandele på det danske fibermarked over de seneste år. 
                Og i et stærkt konkurrenceudsat og prisbevidst bredbåndsmarked, hvor mobilt bredbånd nu også er et alternativ for mange danske 
                forbrugere, er det helt afgørende at levere en god, enkel og brugervenlig kundeoplevelse. Det er ifølge CEO for Hiper, Lars 
                Blach også Hipers strategiske fokus de kommende år, hvor digitaliseringen skal øges på tværs af forretningen til gavn for kunderne:  
            </p>
            <p>
                "På vegne af hele Hiper teamet er jeg stolt og glad for anerkendelsen fra vores kunder. 
                Men vi hviler ikke på laurbærrene. Vi ved, at vi skal levere 110% på kundeoplevelsen fra start 
                til slut for at kunne blive ved med at skille os positivt ud i et yderst konkurrencepræget marked. 
                Vi vil fortsætte med at øge investeringen i den gode kundeoplevelse med ambitionen om at genvinde 
                priser mange år endnu, og vi vil digitalisere forretningen yderligere for at gøre det endnu nemmere 
                at blive fiberkunde hos Hiper,” siger Lars Blach.  
            </p>
        </>
    )
}
